import useTable, { ColumnType } from '@components/Table/useTable'
import {
  renderHeaderTooltip,
  useDropdownMenu
} from '@utils/assessmentReportUtils'
import { Flex } from 'antd'
import { useMemo } from 'react'

import {
  Database_Procs_GetSchoolPlayers_Item,
  Entities_School_WallOfFame_LevelData
} from '@suntex.fim/api-client'

// Column configuration for the table
export const columnConfig =
  (): ColumnType<Database_Procs_GetSchoolPlayers_Item>[] => [
    {
      header: () => renderHeaderTooltip('User Id'),
      id: 'userId',
      accessorKey: 'userId',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Display Name'),
      id: 'displayName',
      accessorKey: 'displayName',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('First Name'),
      id: 'firstName',
      accessorKey: 'firstName',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Last Name'),
      id: 'lastName',
      accessorKey: 'lastName',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Sticker Count(as of Sunday)'),
      id: 'stickers',
      accessorKey: 'stickers',
      cell: (info) => <b>{info.getValue<string>()?.toLocaleString()}</b>,
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Team Name'),
      id: 'teamName',
      accessorKey: 'teamName',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Class Name'),
      id: 'className',
      accessorKey: 'className',
      size: 50,
      enableSorting: false
    },
    {
      header: () => renderHeaderTooltip('Grade'),
      id: 'grade',
      accessorKey: 'grade',
      size: 50,
      enableSorting: false
    }
  ]

// Label configuration for hidden columns when exporting
export const hidableSelectLabel: Record<string, string> = {
  userId: 'User ID',
  displayName: 'Display Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  stickers: 'Sticker Count(as of Sunday)',
  teamName: 'Team Name',
  className: 'Class Name',
  grade: 'Grade'
}

/**
 * Wall of Fame Tool Table Component
 */
function WallOfFameToolTable({
  levelsData,
  isLoading,
  team
}: Readonly<{
  levelsData: Entities_School_WallOfFame_LevelData
  isLoading: boolean
  team: { name?: string } | null
}>) {
  // Memoize column configuration
  const columns = useMemo(() => columnConfig(), [])
  // Initialize table with data, columns, and loading state
  const { table, Table } = useTable({
    data: levelsData.schoolPlayers || [],
    columns,
    isLoading,
    hideFirstTwoColumns: false
  })
  // Dropdown menu items for exporting options
  const dropdownItems = useDropdownMenu({
    table,
    hidableSelectLabel,
    fileName: `${team?.name}_wof_${levelsData.header}`,
    hidePrintPdf: true
  })

  return (
    <Flex vertical gap={16}>
      <Flex
        justify="space-between"
        align="center"
        className="main-result__toolbar"
      >
        <h4>{levelsData.header}</h4>
        <Flex gap="10px"></Flex>
      </Flex>
      <Table />
    </Flex>
  )
}

export default WallOfFameToolTable
